import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCRKvVl-FhGqqfHfOApY4-BzTwA8rf8v5M",
  authDomain: "watchworthy-3635c.firebaseapp.com",
  projectId: "watchworthy-3635c",
  storageBucket: "watchworthy-3635c.firebasestorage.app",
  messagingSenderId: "299596048592",
  appId: "1:299596048592:web:3e0ef51acf9d1f12cb96d5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app); 